import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const ClientSelector = ({ onSelect, onClose }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedClient, setSelectedClient] = useState(null);

  // Mock client data
  const clients = [
    {
      id: 1,
      name: 'Tecnología Avanzada S.L.',
      email: 'contacto@tecavanzada.es',
      phone: '+34 91 123 4567',
      address: 'Calle Mayor 123, 28001 Madrid',
      taxId: 'B12345678',
      contactPerson: 'Carlos Rodríguez'
    },
    {
      id: 2,
      name: 'Innovación Digital S.A.',
      email: 'info@innovaciondigital.com',
      phone: '+34 93 987 6543',
      address: 'Avenida Diagonal 456, 08008 Barcelona',
      taxId: 'A87654321',
      contactPerson: 'María González'
    },
    {
      id: 3,
      name: 'Soluciones Empresariales Ltd.',
      email: 'ventas@solempresariales.es',
      phone: '+34 96 555 0123',
      address: 'Plaza del Ayuntamiento 789, 46002 Valencia',
      taxId: 'B11223344',
      contactPerson: 'Ana Martínez'
    },
    {
      id: 4,
      name: 'Consultoría Integral S.L.',
      email: 'admin@consultoriaintegral.es',
      phone: '+34 95 444 5678',
      address: 'Calle Sierpes 321, 41004 Sevilla',
      taxId: 'B99887766',
      contactPerson: 'José Luis Fernández'
    },
    {
      id: 5,
      name: 'Desarrollo Web Pro S.A.',
      email: 'contacto@webpro.es',
      phone: '+34 98 333 2211',
      address: 'Calle Uría 654, 33003 Oviedo',
      taxId: 'A55443322',
      contactPerson: 'Laura Sánchez'
    },
    {
      id: 6,
      name: 'Sistemas Informáticos Norte',
      email: 'info@sisnorte.com',
      phone: '+34 94 222 1100',
      address: 'Gran Vía 987, 48001 Bilbao',
      taxId: 'B77665544',
      contactPerson: 'Miguel Ángel Ruiz'
    }
  ];

  const filteredClients = clients.filter(client => {
    const searchLower = searchTerm.toLowerCase();
    return client.name.toLowerCase().includes(searchLower) ||
           client.email.toLowerCase().includes(searchLower) ||
           client.contactPerson.toLowerCase().includes(searchLower) ||
           client.taxId.toLowerCase().includes(searchLower);
  });

  const handleClientSelect = (client) => {
    setSelectedClient(client);
  };

  const handleConfirmSelection = () => {
    if (selectedClient) {
      onSelect(selectedClient);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-modal p-4">
      <div className="bg-surface rounded-lg shadow-modal border border-border w-full max-w-4xl max-h-[90vh] flex flex-col">
        {/* Header */}
        <div className="p-4 border-b border-border">
          <div className="flex items-center justify-between">
            <h3 className="text-lg font-heading font-semibold text-text-primary">
              Seleccionar Cliente
            </h3>
            <Button
              variant="ghost"
              size="sm"
              iconName="X"
              onClick={onClose}
            />
          </div>
        </div>

        {/* Search */}
        <div className="p-4 border-b border-border">
          <Input
            type="search"
            placeholder="Buscar por nombre, email, contacto o NIF..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full"
          />
        </div>

        {/* Content */}
        <div className="flex-1 overflow-hidden flex">
          {/* Client List */}
          <div className="flex-1 overflow-y-auto p-4">
            {filteredClients.length === 0 ? (
              <div className="text-center py-8">
                <Icon name="Users" size={48} className="text-text-muted mx-auto mb-4" />
                <p className="text-text-muted">
                  {searchTerm ? 'No se encontraron clientes' : 'No hay clientes registrados'}
                </p>
                <Button
                  variant="outline"
                  size="sm"
                  iconName="Plus"
                  className="mt-4"
                  onClick={() => console.log('Create new client')}
                >
                  Crear Nuevo Cliente
                </Button>
              </div>
            ) : (
              <div className="space-y-3">
                {filteredClients.map((client) => {
                  const isSelected = selectedClient?.id === client.id;
                  
                  return (
                    <div
                      key={client.id}
                      onClick={() => handleClientSelect(client)}
                      className={`p-4 rounded-lg border cursor-pointer transition-micro ${
                        isSelected
                          ? 'border-primary bg-primary-50' :'border-border hover:border-primary-200 hover:bg-secondary-50'
                      }`}
                    >
                      <div className="flex items-start justify-between">
                        <div className="flex-1 min-w-0">
                          <h4 className="font-medium text-text-primary truncate">
                            {client.name}
                          </h4>
                          <p className="text-sm text-text-secondary">
                            {client.contactPerson}
                          </p>
                          <p className="text-sm text-text-muted">
                            {client.email}
                          </p>
                        </div>
                        
                        <div className="ml-4 text-right">
                          <p className="text-sm text-text-secondary">
                            {client.phone}
                          </p>
                          <p className="text-xs text-text-muted">
                            NIF: {client.taxId}
                          </p>
                        </div>
                      </div>
                      
                      <div className="mt-2 text-sm text-text-muted">
                        <Icon name="MapPin" size={14} className="inline mr-1" />
                        {client.address}
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>

          {/* Selected Client Details */}
          {selectedClient && (
            <div className="w-80 border-l border-border p-4 bg-secondary-50">
              <h4 className="font-medium text-text-primary mb-4">
                Cliente Seleccionado
              </h4>
              
              <div className="space-y-4">
                <div>
                  <h5 className="font-medium text-text-primary">
                    {selectedClient.name}
                  </h5>
                  <p className="text-sm text-text-muted">
                    NIF: {selectedClient.taxId}
                  </p>
                </div>
                
                <div>
                  <h6 className="text-sm font-medium text-text-primary mb-1">
                    Persona de Contacto
                  </h6>
                  <p className="text-sm text-text-secondary">
                    {selectedClient.contactPerson}
                  </p>
                </div>
                
                <div>
                  <h6 className="text-sm font-medium text-text-primary mb-1">
                    Email
                  </h6>
                  <p className="text-sm text-text-secondary">
                    {selectedClient.email}
                  </p>
                </div>
                
                <div>
                  <h6 className="text-sm font-medium text-text-primary mb-1">
                    Teléfono
                  </h6>
                  <p className="text-sm text-text-secondary">
                    {selectedClient.phone}
                  </p>
                </div>
                
                <div>
                  <h6 className="text-sm font-medium text-text-primary mb-1">
                    Dirección
                  </h6>
                  <p className="text-sm text-text-secondary">
                    {selectedClient.address}
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="p-4 border-t border-border bg-secondary-50">
          <div className="flex items-center justify-between">
            <div className="text-sm text-text-muted">
              {selectedClient ? 'Cliente seleccionado' : 'Seleccione un cliente'}
            </div>
            
            <div className="flex items-center space-x-3">
              <Button
                variant="outline"
                onClick={onClose}
              >
                Cancelar
              </Button>
              
              <Button
                variant="primary"
                onClick={handleConfirmSelection}
                disabled={!selectedClient}
                iconName="Check"
              >
                Seleccionar Cliente
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClientSelector;